import { CSSProperties } from "react";

export type EventApiProps = {
  pointerEvents?: CSSProperties["pointerEvents"];
  cursor?: CSSProperties["cursor"];
};

export const eventApi = (props: EventApiProps) => ({
  pointerEvents: props.pointerEvents,
  cursor: props.cursor,
});
